import './TopMenu.less';

const topMenu = (() =>{
    const handleMenuOpening = () => {
        let togglers = Array.from(document.querySelectorAll('.js-top-menu-toggler'));
        let menu = document.querySelector('#js-top-menu');
    
        togglers.forEach(toggler => toggler.addEventListener('click', () => { menu.classList.toggle('opened') } ));
    };
    
    const handleSubmenu = () => {
        let openers = Array.from(document.querySelectorAll('.js-open-submenu, .top-menu__link--submenu'));
        
        const openSubmenu = opener => {
            let closestSubmenu = opener.parentElement.getElementsByTagName('ul')[0];
            
            opener.classList.toggle('opened');
            closestSubmenu.classList.toggle('opened');
        };
        openers.forEach(opener => opener.addEventListener('click', () => openSubmenu(opener)));
    };
    
    handleMenuOpening();
    handleSubmenu();
})();

export default topMenu;